import React from 'react';

import OfferActivateProfile from './OfferActivateProfile.component';

export default function OfferShell({
  children,
  user,
}: {
  children?: React.ReactNode;
  user?: { public?: boolean } | null;
}) {
  return (
    <section className="container container-spacer offer">
      {!user?.public && <OfferActivateProfile />}
      {user?.public && children}
    </section>
  );
}
